import omit from 'lodash/omit';

import { sortByOptions } from 'constants/sortByOptions';
import { log } from 'utils/error-logging';

import { UPDATESEARCH } from 'redux/modules/search/actions/types';
import { TRANSFORM_GRID_ITEMS } from 'redux/transforms';
import { COMPONENTS_AND_PRODUCTS_SCHEMA } from 'redux/schemas';

import { ensureSortByIsSet } from 'redux/modules/search/actions/helpers';

import { fetchComponentsAndProducts } from 'redux/modules/search-and-browse/actions/fetch-components-and-products';
import { clearLocations } from 'redux/modules/content/actions/clear-locations';
import { clearSearch } from 'redux/modules/search/actions/clear-search';

import { getCustomerId, getCustomerOrderId } from 'redux/modules/sessions/selectors';

export const searchProductsByCustomAisle = ({ params: rawParams, refinement }) => {
  const params = ensureSortByIsSet(rawParams, sortByOptions.customAisle);

  return (dispatch, getState) => {
    dispatch(clearSearch(refinement));

    if (!refinement) {
      dispatch(clearLocations());
    }

    dispatch({
      type: UPDATESEARCH,
      params: {
        size: 48,
        ...params,
      },
    });

    const { aisleRef, rootCategory } = params;
    const customerId = getCustomerId(getState());
    const orderId = getCustomerOrderId(getState());
    const request = {
      api: 'customaisle',
      body: {
        contentUrl: `/shop/featured/${rootCategory}/${aisleRef}`,
        customerId,
        customerSearchRequest: {
          queryParams: {
            orderId,
            size: 48,
            ...omit(params, ['aisleRef', 'rootCategory']),
          },
        },
      },
      method: 'put',
      name: 'CustomAisle',
      properties: {
        aisleRef,
        iHandleStatusCodes: [400, 404],
        rootCategory,
      },
      schema: COMPONENTS_AND_PRODUCTS_SCHEMA,
      transform: TRANSFORM_GRID_ITEMS,
    };

    return dispatch(fetchComponentsAndProducts({ request })).catch(error => {
      log(error, {
        context: {
          level: 'warning',
        },
      });
    });
  };
};
